module.exports = __webpack_public_path__ + "img/by-nc-nd.63fd68f6.png";